import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MvsCrudService} from '../../../core/shared/service/crud/mvs-crud.service';

/**
 * CRUD service for {@code vs.Visit}.
 *
 * Provides standard CRUD operations via {@link MvsCrudService} for the Visit
 * entity. A dedicated service file is required (instead of route-only registration)
 * because the component specialist will wire {@code getObjectComponent()} in the
 * entity-provider to a crud-object component, and may add custom business methods
 * (e.g. geo-capture helper, visit start/end lifecycle calls) in follow-on waves.
 *
 * Per MvsCrudService skill SC6/SC7: the service file exists because this entity
 * participates in the dialog/component framework via the entity-provider
 * {@code objectComponent} array — the {@code CallService} precedent confirms
 * this pattern for visit-style entities.
 *
 * @ticket TM-1000001921
 */
@Injectable({providedIn: 'root'})
export class VisitService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/vs/visits');
    }

}
